import { QrCode } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizePhone } from '@farmos/shared';
import { Button } from '@farmos/ui/button';
import { Field } from '@farmos/ui/field';
import { Input } from '@farmos/ui/input';
import { supabase } from '@/supabase';

/** Workers sign in by scanning their QR code; this form is for phone or email with a password. */
export function LoginPage() {
  const { t } = useTranslation();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setError('');
    const phone = id.includes('@') ? null : normalizePhone(id);
    const { error: e } = await supabase.auth.signInWithPassword(
      phone ? { phone, password } : { email: id.trim(), password },
    );
    setBusy(false);
    if (e) setError(t('login.failed'));
  };

  return (
    <main className="grid min-h-dvh place-items-center px-5">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <h1 className="text-3xl font-semibold tracking-tight">FarmAI</h1>
          <p className="text-muted">{t('app.tagline')}</p>
        </div>
        <div className="flex gap-3 rounded-[22px] bg-brand-soft p-4 text-sm text-brand-2">
          <QrCode className="size-6 shrink-0" aria-hidden />
          <p>{t('login.qr_hint')}</p>
        </div>
        <form
          className="space-y-3 rounded-[26px] bg-panel p-5 shadow-card"
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}
        >
          <h2 className="font-semibold">{t('login.title')}</h2>
          <Field label={t('login.id')}>
            <Input
              dir="ltr"
              autoComplete="username"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
          </Field>
          <Field label={t('login.password')} error={error || undefined}>
            <Input
              type="password"
              dir="ltr"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          <Button type="submit" className="w-full" disabled={busy || !id || !password}>
            {t('login.submit')}
          </Button>
        </form>
      </div>
    </main>
  );
}
